import { useMutation, useQueryClient } from "@tanstack/react-query";
import { replaceReminderInListCaches } from "web_myplann/Api/Reminders/remindersCacheUtils";
import {
	patchRemindersIdV2,
	type UpdateReminderResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import { formatApiDate } from "web_myplann/Shared/Utils/apiDate";

export const useReminderResolveMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<UpdateReminderResponseDTO, Error, string>({
		// BE reschedules recurring reminders to the next occurrence on solve.
		mutationFn: processResponse((id: string) =>
			patchRemindersIdV2({ solvedAt: formatApiDate(new Date()) }, Number(id)),
		),
		onSuccess: (data) => {
			replaceReminderInListCaches(queryClient, data);
		},
	});
};
